import { IconButton } from '@yanolja-rnd/nol-design-system'
import { IcClose } from '@yanolja-rnd/nol-icons'
import useModalHash from '~/app/components/common/useModalHash'
import DeleteConfirmDialog from './delete-confirm-dialog'

interface OptionDeleteButtonProps
  extends Omit<
    React.ComponentProps<typeof IconButton>,
    'icon' | 'theme' | 'size' | 'className' | 'onClick'
  > {
  optionId: string
}

const OptionDeleteButton = ({ optionId, ...props }: OptionDeleteButtonProps) => {
  /** 선택한 상품 삭제 확인 다이얼로그 표시 여부 */
  const [isDeleteConfirmDialogOpen, setDeleteConfirmDialogOpen] = useModalHash({
    id: `delete-confirm-dialog-${optionId}`,
  })

  return (
    <>
      <IconButton
        size="small"
        className="h-20 min-h-20 w-20 min-w-20 p-0 pc:min-h-20"
        icon={<IcClose width={20} height={20} />}
        theme="ghost"
        onClick={() => setDeleteConfirmDialogOpen(true)}
        {...props}
      />
      <DeleteConfirmDialog
        isOpen={isDeleteConfirmDialogOpen}
        onClose={() => setDeleteConfirmDialogOpen(false)}
        optionId={optionId}
      />
    </>
  )
}

export default OptionDeleteButton
